<template>
  <div>
    <Header></Header>
    <div class="articleCon">
        <div class="top">
            <div class="title">ARTICLE</div>
            <div class="search">
                <div class="searchBox">
                <div class="left"></div>
                <div class="right">
                    <input type="text" @change="search" v-model="inputValue" />
                </div>
                </div>
            </div>
        </div>
        <div class="content">
          <div class="box" @click="showModal(item.id)"  v-for="item,id in items" :key="id">
            <div class="cover">
              <img :src="item.image" alt="">
            </div>
            <div class="boxData">
              <div class="title">{{item.title}}</div>
              <div class="author">{{item.author}}</div>
            </div>
          </div>
          <div class="pagination">
            <el-pagination
              :small="true"
              :background="true"
              :current-page="query.page"
              :page-sizes="[16, 32, 48, 60]"
              :page-size=16
              :pager-count=5
              layout="prev, pager, next"
              :total="query.count"
              :hide-on-single-page="true"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              >
            </el-pagination>
          </div>
        </div>
        <div class="modal" ref="modal">
            <a-modal
                v-model="visible"
                :getContainer="() => $refs.modal"
                width="calc(100vw - 20px)"
                :zIndex=3
                centered
                :footer="null"
                :closable="false"
                :destroyOnClose="true"
            >
                <p v-html="item"></p>
            </a-modal>
            <div class="return" v-if="visible" @click="closeModal"></div>
            <div class="last" v-if="visible"></div>
            <div class="next" v-if="visible"></div>
        </div>
    </div>
  </div>
</template>
<script>
import Header from '../../components/Header_M.vue'
export default{
  components:{
      Header
  },
  data() {
    return {
      inputValue:'',
      visible: false,
      items:[],
      item:{},
      query: {
        page:1,
        limit: 16,
        sort: { _id: -1 },
        where:{
          status:10
        }
      },
    };
  },
  created(){
    this.getData()
  },
  methods: {
    async getData() {
      const article = await this.$axios.get("article", {
        params: {
          query: this.query,
        },
      });
      this.query.count = article.data.total
      this.items = article.data.data;
    },
    async getArt(id) {
      const article = await this.$axios.get("article/"+id, {
      });
      this.item = article.data.body;
    },
    async search() {
      this.query = {
        limit: 16,
        sort:{"_id":-1},
        where:{"title" :{"$regex":this.inputValue }}
      }
      this.getData()
    },
    showModal(id) {
      this.visible = true;
      this.getArt(id)
    },
    closeModal(){
      this.visible = false;
      this.item = {}
    },
    handleSizeChange(val) {
      this.query.pageSize = val;
      this.getData()
    },
    handleCurrentChange(val) {
      this.query.page = val;
      this.getData()
    }
  },
};
</script>
<style scoped>
.articleCon{
    width: 100vw;
    height: 100vh;
    padding-top: 51px;
    background-color: #000;
}
.articleCon .content .articleHr{
  width: 100%;
  border: none;
  height: 1px;
  background: #888;
}
.articleCon .top{
    width: calc(100vw - 20px);
    height: 70px;
    background-color: #000;
    border-bottom: #888 1px solid;
    position: fixed;
    display: inline-block;
    margin: 0 10px;
    z-index: 2;
}
.articleCon .top .title{
    width: 50%;
    font-size: 22px;
    line-height: 70px;
    font-weight: bold;
    color: #fff;
    float: left;
}
.articleCon .top .search{
    width: 50%;
    float: right;
    transform: translateY(20px);
}
.articleCon .top .search .searchBox {
  width: 100%;
    height: 30px;
    float: right;
  display: flex;
}
.articleCon .top .search .searchBox .left {
  width: 30px;
  height: inherit;
  border: #999 1px solid;
  background: transparent url("../../assets/search.png") center no-repeat;
  background-size: 60%;
}
.articleCon .top .search .searchBox .right {
  width: calc(100% - 30px);
  height: inherit;
  grid-area: 1 / 2 / 2 / 3;
  border: #888 1px solid;
  border-left: none;
}
.articleCon .top .search .searchBox .right input {
  width: calc(100% - 30px - 1px);
  height: calc(100% - 2px);
  background: #000;
  color: #fff;
  font-size: 16px;
  padding: 5px;
  box-sizing: border-box;
  border: none;
  position: absolute;
}
input:focus {
  outline: none;
}
.articleCon .top .articleHr {
    width: inherit;
    border: none;
    height: 1px;
    background: #888;
}
.articleCon .content{
    width: 100vw;
    height: calc(100vh - 51px);
    position: fixed;
    padding: 20px 10px;
    padding-top: 70px;
    overflow: scroll;
    /* display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    overflow: scroll; */
}
.articleCon .content .box{
    height: 120px;
    padding: 15px 0;
    box-sizing: content-box;
    border-bottom: #888 solid 1px;
    color: #fff;
    width: 100%;
    display: inline-flex;
}
.articleCon .content .box:last-of-type{
    border-bottom: none;
}
.articleCon .content .box .cover{
    width: 120px;
    height: inherit;
    background-color: #222;
    float: left;
}
.articleCon .content .box .cover img{
  width: 100%;
  height: inherit;
  object-fit: cover;
}
.articleCon .content .box .boxData{
    width: 66%;
    height: inherit;
    float: right;
}
.articleCon .content .box .boxData .title{
    font-size: 15px;
    line-height: 25px;
    padding-left: 10px;
}
.articleCon .content .box .boxData .author{
    font-size: 14px;
    line-height: 20px;
    padding-left: 10px;
}
.articleCon .content .pagination{
  width: inherit;
  text-align: center;
  padding: 5px 0;
}
.articleCon .content .pagination /deep/ .el-pagination .el-select .el-input .el-input__inner {
    padding-right: 25px;
    background: #000;
    color: #fff;
    border-radius: 0;
    border: 1px solid #999;
}
.articleCon .content .pagination /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: #999;
    color: #fff;
}
.articleCon .content .pagination /deep/ .el-pagination.is-background .el-pager li,
.articleCon .content .pagination /deep/ .el-pagination.is-background .btn-next,
.articleCon .content .pagination /deep/ .el-pagination.is-background .btn-prev{
    border-radius: 0;
    background: #000;
    color: #fff;
    border: 1px solid #999;
}
.articleCon .content .pagination /deep/ .el-pagination__editor.el-input .el-input__inner,
.articleCon .content .pagination /deep/ .el-pagination__jump{
    background: #000;
    color: #fff;
}
/* .articleCon .updown {
    width: 20px;
    height: 70vh;
    background: transparent url('../../assets/updown.png') right center no-repeat;
    background-size: contain;
    position: fixed;
    top: 180px;
    right: 10px;
} */

.modal /deep/ .ant-modal {
    max-width: 100vw;
    height: calc(100vh - 70px);
    overflow: hidden;
    padding: 0;
    margin: 0;
    border-radius: 0;
}
.modal /deep/ .ant-modal-wrap {
    width: calc(100vw);
    height: calc(100vh - 70px);
    transform: translateY(60px);
}
.modal /deep/ .ant-modal-mask{
  background-color: #000;
}
.modal /deep/ .ant-modal-content {
  height: calc(100vh - 100px);
  overflow: hidden;
  background-color: #000;
  border: #888 1px solid;
  color: #888;
}
.modal /deep/ .ant-modal-body {
  height: calc(100vh - 100px);
  overflow-x: hidden;
  overflow-y: scroll;
}
.modal /deep/ .ant-modal-body img,
.modal /deep/ .ant-modal-body svg{
  width: 100% !important;
  max-width: 100%;
  height: auto !important;
  object-fit: contain;
}
.modal /deep/ .ant-modal-body h1{
  color: #fff;
  font-size: 18px;
}
.modal /deep/ .ant-modal-body p,
.modal /deep/ .ant-modal-body span,
.modal /deep/ .ant-modal-body strong,
.modal /deep/ .ant-modal-body section{
  color: #fff !important;
  /* background-color: #000 !important; */
  background-image: none !important;
  margin: 0;
  filter: drop-shadow(0 0 0.4px #000);
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar {
  width: 15px;
  background: #000;
  border: 1px solid #888;
  display: block;
}
.modal /deep/ .ant-modal-body::-webkit-scrollbar-thumb {
  background-color: #fff;
}
.modal .return {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: absolute;
  z-index: 5;
  right: 30px;
  bottom: 20px;
  background: #000 url("../../assets/return.png") center no-repeat;
  background-size: 60%;
}
.modal .last {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: absolute;
  z-index: 5;
  left: 30px;
  bottom: 20px;
  background: #000 url("../../assets/last.png") center no-repeat;
  background-size: 30%;
}
.modal .next {
  color: #888;
  width: 40px;
  height: 40px;
  border-radius: 20px;
  border: #888 1px solid;
  position: absolute;
  z-index: 5;
  left: 80px;
  bottom: 20px;
  background: #000 url("../../assets/next.png") center no-repeat;
  background-size: 30%;
}
</style>


// WEBPACK FOOTER //
// src/view/mobile/Article.vue